<template>
  <!-- NOTE (TEMPLATE) to show all proposals -->

  <div class="animated fadeIn changeLog c-dark font-weight-bold">
    <b-tabs pills vertical card>
      <b-tab title="تغییرات آخرین نسخه">
        <h5>نسخه 2.5.0</h5>
        <ul>
          <li class="text-primary">تاریخ انتشار: 12 بهمن 1401</li>
          <li>بروزرسانی و بهبود نقشه زیست فناوری</li>
          <li>تکمیل پروفایل استان‌ها در نقشه زیست فناوری</li>
          <li>امکان ارائه پروفایل تکمیلی برای دانشگاه‌های ممتاز</li>
          <li>قابلیت مشاهده دانشگاه‌های ممتاز در نقشه زیست فناوری</li>
          <li>امکان ارائه پروفایل تکمیلی برای پژوهشگر‌های ممتاز</li>
          <li>قابلیت مشاهده پژوهشگر‌‌های ممتاز در نقشه زیست فناوری</li>
          <li>
            افزودن قابلیت گزارش‌گیری پیشرفته شتاب‌دهنده‌ها برای مدیر سامانه
          </li>
          <li>
            افزودن قابلیت گزارش‌گیری فعالیت نقش‌های مختلف سامانه برای مدیر
            سامانه
          </li>
          <li>افزوده شدن محور چهارم برای دانشگاه</li>
          <li>قابلیت مدیریت شهر‌ها و استان‌ها برای مدیر سامانه</li>
          <li>قابلیت مدیریت تنظیمات نقشه برای مدیر سامانه</li>
          <li>بهبود عملکرد و ظاهر سامانه</li>
          <li>رفع ایرادات و بهبود رابط کاربری</li>
        </ul>
      </b-tab>
      <b-tab title="تاریخچه بروزرسانی‌های سامانه">
        <ul>
          <li class="version-major">نسخه 1.0.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 22 آبان 1399</li>
            <li>رونمایی اولیه از سامانه برای پژوهشگر</li>
          </ul>
          <li class="version-patch">نسخه 1.0.1</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 23 آبان 1399</li>
            <li>
              رفع ایراد ذخیره‌سازی و نمایش رنگ گانت چارت و تیک مربوط به
              گزارش‌گیری
            </li>
          </ul>
          <li class="version-minor">نسخه 1.1.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 26 آبان 1399</li>
            <li>
              رونمایی از ماژول ادمین برای نظارت بر عملکرد پژوهشگر و داوران
            </li>
            <li>
              رونمایی از ماژول داوران برای انجام فرایند داوری و محاسبه خودکار
              نمره هر درخواست
            </li>
            <li>بهبود نحوه نمایش و بروزرسانی تاریخچه</li>
            <li>بهبود نحوه تعامل پژوهشگر با فیلد دانشگاه</li>
            <li>رفع ایراد مربوط به محاسبه هزینه نهایی</li>
            <li>بهبود رابط کاربری آپلود فایلها</li>
            <li>رفع ایرادهای مربوط به نمایش طرح برای پژوهشگر</li>
            <li>رفع ایرادهای موجود در پروفایل داور برای تغییر رمز عبور</li>
            <li>
              رفع ایراد مربوط به انتخاب دانشگاه محل اشتغال به عنوان عضوهئیت علمی
              در ثبت حمایت‌ها
            </li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-minor">نسخه 1.2.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 27 آبان 1399</li>
            <li>رونمایی از ماژول دانشگاه‌ها</li>
            <li>رفع ایراد فیلد آخرین مدرک تحصیلی برای پژوهشگر</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-patch">نسخه 1.2.1</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 1 آذر 1399</li>
            <li>تکمیل ابزار مدیریت</li>
            <li>بهبود فرایند ثبت مقاله</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-minor">نسخه 1.3.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 5 آذر 1399</li>
            <li>افزودن قابلیت ثبت سریع حمایت توسط ادمین</li>
            <li>افزودن قابلیت تعریف سریع کاربر توسط ادمین</li>
            <li>کنترل سطح دسترسی در صفحات ناشناس</li>
            <li>بهبود عملکرد ماژول داوران و فرایند داوری</li>
            <li>
              بهبود ماژول ادمین و نمایش جامع اطلاعات در قالب نمودار خطی و دایره
              ای
            </li>
            <li>اعمال محدودیت برروی فرمت و حجم بارگذاری فایل ها</li>
            <li>بهبود نحوه عملکرد تاریخچه ی ادمین</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>

          <li class="version-minor">نسخه 1.4.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 11 آذر 1399</li>
            <li>
              ارتقا سطح امنیت سامانه با استفاده از فناوری ریکپچا و محافظت از
              سامانه در برابر ربات ها
            </li>
            <li>
              ارتقا سطح امنیت اطلاعات کاربران با استفاده از بررسی امنیتی پسورد
              انتخابی
            </li>
            <li>افزودن قابلیت بازیابی رمز عبور برای تمامی ماژول ها</li>
            <li>
              افزودن نسخه برای درخواست های ثبت شده توسط پژوهشگر و سهولت فرایند
              پیگیری درخواست
            </li>
            <li>بهبود روند محاسبه ی هزینه ها هنگام ثبت درخواست ها</li>
            <li>افزودن وضعیت جدید برای درخواست های اصلاح شده</li>
            <li>
              افزودن قابلیت تغییر رمز عبور برای ماژول های مدیر و رئیس گروه
            </li>
            <li>افزودن حساب کاربری برای ماژول داور جهت مدیریت بهتر</li>
            <li>امکان مشاهده ی دلایل رد درخواست توسط پژوهشگر</li>
            <li>بهبود ماژول داوری و فرایند داوری</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-minor">نسخه 1.5.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 16 آذر 1399</li>
            <li>افزودن دسترسی به نسخه‌های پیشین درخواست‌ها برای ادمین</li>
            <li>
              افزودن بخش گزارش‌ها برای مدیریت بهتر گزارش‌ها در ماژول ادمین
            </li>
            <li>رفع مشکل دانشگاه‌های محل اشتغال</li>
            <li>
              نمایش تمامی درخواست‌های یک پژوهشگر به صورت یکپارچه در ماژول ادمین
            </li>
            <li>بهبود عملکرد پروفایل دانشگاه</li>
          </ul>

          <li class="version-patch">نسخه 1.5.1</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 17 آذر 1399</li>
            <li>بهبود در عملکرد بارگذاری صفحات</li>
            <li>بهبود عملکرد صفحه‌ی ورود به سامانه</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>

          <li class="version-patch">نسخه 1.5.2</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 19 آذر 1399</li>
            <li>قابلیت دریافت خروجی طرح به صورت فایل Word</li>
            <li>بهبود عملکرد نسخه‌های پیشین</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-minor">نسخه 1.6.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 22 آذر 1399</li>
            <li>
              قابلیت دریافت هر حمایت‌ به صورت یک فایل یکپارچه برای تمامی
              ماژول‌ها
            </li>
            <li>
              بهبود در عملکرد محاسبه‌ی درصد اطلاعات مقاله‌ها و اختراع‌ها در
              پسادکتری
            </li>
            <li>
              بهبود نحوه‌ی نمایش loading برای شناسایی doi در صفحه‌ی مقاله‌ها
            </li>
            <li>بهبود نمایش تاریخچه تغییرات</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-patch">نسخه 1.6.1</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 1 دی 1399</li>
            <li>
              اضافه کردن راهنما به فیلدهای غیر فعال جهت جلوگیری از ایجاد ابهام
            </li>
            <li>بهبود نحوه نمایش چکیده‌ها</li>
            <li>بررسی اطلاعات مقالات قدیمی جهت جلوگیری از خطا در داوری</li>
            <li>بهبود نحوه‌ی مدیریت دانشگاه‌ها در ماژول‌ ادمین</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-minor">نسخه 1.7.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 8 دی 1399</li>

            <li>مدیریت پروژه و پیگیری روند اجرای پروژه‌ها</li>
          </ul>
          <li class="version-minor">نسخه 1.8.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 20 دی 1399</li>
            <li>تغییر در ساختار مقاله، پایان‌نامه ارشد و رساله</li>
            <li>ارتقا اطلاعات پروفایل داور</li>
            <li>بهبود نحوه‌ی بارگذاری فایل‌ها در سامانه</li>
            <li>بهبود تاریخچه ادمین</li>
            <li>قابلیت ارسال پیام از جانب ادمین به داور</li>
            <li>بهبود عملکرد بخش گزارش‌ خطا</li>
            <li>بهبود در فرایند کنترل پروژه</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-patch">نسخه 1.8.1</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 24 دی 1399</li>
            <li>افزودن عنوان پژوهشگر در تمامی جدول ها در ماژول ادمین</li>
            <li>بهبود در نحوه ثبت درخواست در حمایت های طرح و پسادکتری</li>
            <li>بهبود در نحوه نمایش مقالات تایید شده در ماژول ادمین</li>
            <li>ارتقا تاریخچه ی ادمین و ثبت داوری های منقضی شده</li>
            <li>بهبود در فرایند کنترل پروژه</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-patch">نسخه 1.8.2</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 5 بهمن 1399</li>
            <li>بهبود در نحوه ی نمایش کنترل پروژه در ماژول پژوهشگر و ادمین</li>
            <li>
              اضافه کردن اطلاعات بانکی در کنترل پروژه ی پایان نامه کارشناسی ارشد
              و رساله دکتری
            </li>
            <li>بهبود در نحوه ی تعریف گزارش توسط ادمین در کنترل پروژه</li>
            <li>بهبود در نحوه ی مدیریت وضعیت درخواست ها</li>
            <li>ارتقاء زمان بندی در نشست تخصصی</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-minor">نسخه 1.9.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 14 بهمن 1399</li>
            <li>
              اضافه شدن اطلاعات بانکی پژوهشگر، استاد راهنما و استاد مشاور در
              کنترل پروژه پایان نامه ارشد و رساله دکتری
            </li>
            <li>بهبود در نحوه بارگذاری تمامی فایل های سامانه</li>
            <li>تعریف وضعیت برای هر محور</li>
            <li>بهبود تاریخچه کنترل پروژه ادمین</li>
            <li>
              بهبود دلایل رد درخواست و امکان انتخاب چند دلیل و نمایش آن به
              پژوهشگر
            </li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-patch">نسخه 1.9.1</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 03 اسفند 1399</li>
            <li>
              اضافه کردن راهنمای استفاده از سامانه به صورت تصویری و پی دی اف
              برای پژوهشگر
            </li>
            <li>
              اضافه کردن راهنمای ثبت شناسه دیجیتال با فرمت صحیح در ثبت مقاله
            </li>
            <li>بهبود آرشیو کنترل پروژه پژوهشگر</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-major">نسخه 2.0.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 25 اسفند 1399</li>

            <li>
              تغییر زیرساخت استفاده شده و بهبود سرعت و عملکرد سامانه به صورت
              عمومی
            </li>
            <li>بهبود عملکرد نحوه‌ی بررسی شناسه دیجیتال مقالات</li>
            <li>بهبود عملکرد تغییر وضعیت درخواست در ماژول ادمین</li>
            <li>تفکیک نام و نام خانوادگی کاربران سامانه</li>
            <li>رفع ایرادهای دیگر و بهبود عملکرد سامانه</li>
          </ul>
          <li class="version-major">نسخه 2.2.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 4 دی 1400</li>

            <li>افزودن بخش امور اجرایی به منوی ادمین سامانه</li>
            <li>
              دسته بندی حمایت‌ها با توجه به وضعیت آن‌ها جهت دسترسی و دید بهتر
              نقش ادمین
            </li>
            <li>
              افزودن دکمه‌های اقدامات سریع به صفحات امور اجرایی جهت افزایش سرعت
              بررسی حمایت‌ها
            </li>
            <li>
              افزودن دکمه سایر کنار فیلد‌های انتخاب دانشگاه جهت انتخاب راحت‌تر
              گزینه سایر دانشگاه‌ها
            </li>
          </ul>
          <li class="version-major">نسخه 2.3.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 18 دی 1400</li>

            <li>افزودن نقش شرکت به سامانه</li>
            <li>افزودن عکس لوگو و گالری تصاویر به نقش دانشگاه</li>
            <li>افزودن نقشه تعاملی به سامانه</li>
            <li>
              نمایش اطلاعات استان از قبیل شرکت‌ها و دانشگاه‌های واقع در استان و
              نمودار آمار حمایت‌ها
            </li>
            <li>افزودن صفحات نمایش عمومی پروفایل دانشگاه‌ها و شرکت‌ها</li>
          </ul>
          <li class="version-major">2.4.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 12 خرداد 1401</li>

            <li>افزودن شتاب‌دهنده به عنوان نقش جدید در سامانه</li>
            <li>افزودن صفحه نمایش عمومی پروفایل شتاب‌دهنده</li>
            <li>بروزرسانی و بهبود نقشه زیست فناوری</li>
            <li>افزودن قابلیت گزارش‌گیری پیشرفته برای مدیر سامانه</li>
            <li>شبکه‌سازی اولیه بین شتاب‌دهنده‌ها و پژوهشگران</li>
            <li>قابلیت ثبت درخواست حمایت بدون اطلاعات تجاری‌سازی</li>
            <li>
              قابلیت ویرایش و حذف اطلاعات تجاری‌سازی یک حمایت توسط مدیر سامانه
            </li>
            <li>افزودن خروجی اکسل برای جداول نقش مدیر سامانه</li>
            <li>بهبود عملکرد و ظاهر سامانه</li>
            <!-- <li>افزایش سرعت گزارش‌گیری</li> -->
            <li>رفع ایرادات و بهبود رابط کاربری</li>
          </ul>
          <li class="version-major">2.5.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 12 بهمن 1401</li>
            <li>بروزرسانی و بهبود نقشه زیست فناوری</li>
            <li>تکمیل پروفایل استان‌ها در نقشه زیست فناوری</li>
            <li>امکان ارائه پروفایل تکمیلی برای دانشگاه‌های ممتاز</li>
            <li>قابلیت مشاهده دانشگاه‌های ممتاز در نقشه زیست فناوری</li>
            <li>امکان ارائه پروفایل تکمیلی برای پژوهشگر‌های ممتاز</li>
            <li>قابلیت مشاهده پژوهشگر‌‌های ممتاز در نقشه زیست فناوری</li>
            <li>
              افزودن قابلیت گزارش‌گیری پیشرفته شتاب‌دهنده‌ها برای مدیر سامانه
            </li>
            <li>
              افزودن قابلیت گزارش‌گیری فعالیت نقش‌های مختلف سامانه برای مدیر
              سامانه
            </li>
            <li>افزوده شدن محور چهارم برای دانشگاه</li>
            <li>قابلیت مدیریت شهر‌ها و استان‌ها برای مدیر سامانه</li>
            <li>قابلیت مدیریت تنظیمات نقشه برای مدیر سامانه</li>
            <li>بهبود عملکرد و ظاهر سامانه</li>
            <li>رفع ایرادات و بهبود رابط کاربری</li>
          </ul>
        </ul>
      </b-tab>
      <!-- <b-tab title="برنامه‌ریزی بروزرسانی‌های آتی">
        <ul>
          <li class="version-major-future">نسخه 2.0.0</li>
          <ul>
            <li class="text-primary">تاریخ انتشار: 10 اسفند 1399</li>
            <li>
              تغییر زیرساخت استفاده شده و بهبود سرعت و عملکرد سامانه به صورت
              عمومی
            </li>
          </ul>
        </ul>
      </b-tab> -->
    </b-tabs>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {};
  },

  methods: {},
  updated() {},
  mounted() {},
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.bg-primary {
  background-color: #693d70 !important;
}
.color {
  background-color: #0c4961;
  color: white;
}
.changeLog {
  .nav-pills {
    padding-right: 20px;
    font-weight: 400;
    li {
      list-style: none;
    }
  }
  ul {
    padding-right: 15px;
    li {
      list-style: disc;
      padding: 3px 0;
    }
    .text-primary {
      list-style: circle;
    }
  }
}
.version-major {
  font-weight: bold;
  font-size: 135%;
  margin-top: 25px;
}

.version-minor {
  font-weight: bold;
  font-size: 120%;
  margin-top: 15px;
  margin-right: 15px;
}

.version-patch {
  font-style: italic;
  margin-top: 5px;
  margin-right: 25px;
}

.version-major-future {
  font-weight: bold;
  font-size: 135%;
  color: gray;
  margin-top: 25px;
}

.version-minor-future {
  font-weight: bold;
  font-size: 120%;
  color: gray;
  margin-top: 15px;
  margin-right: 15px;
}

.version-patch-future {
  font-style: italic;
  color: gray;
  margin-top: 5px;
  margin-right: 25px;
}
</style>
